import * as React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ISelectableMetric, ITest } from '../../../../data/types';
import { roundValue } from '../../../../utils/math';

interface IProps {
  test: ITest;
  rank: number;
  metric: ISelectableMetric;
  onTestClick: (test: ITest) => void;
}

export const ScoreboardRankRow = ({
  test,
  rank,
  metric,
  onTestClick,
}: IProps): React.ReactElement => (
  <Flex
    align='center'
    w='100%'
    px={4}
    py={4}
    bg='var(--scoreboard-card-bg, rgba(0, 0, 0, 0.85))'
    borderRadius='lg'
    cursor='pointer'
    transition='all 0.15s ease-in-out'
    _hover={{
      bg: 'var(--scoreboard-card-bg-hover, rgba(0, 0, 0, 0.95))',
    }}
    onClick={(): void => onTestClick(test)}
    role='listitem'
    aria-label={`Rank ${rank}: ${test.athlete?.name}`}
    tabIndex={0}
    onKeyDown={(e: React.KeyboardEvent): void => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onTestClick(test);
      }
    }}
  >
    <Text
      fontSize='24px'
      fontWeight={700}
      color='var(--scoreboard-secondary, #4285f4)'
      minW='80px'
    >
      {rank}
    </Text>
    <Text
      flex={1}
      fontSize='18px'
      fontWeight={500}
      color='var(--scoreboard-text-primary, #ffffff)'
      overflow='hidden'
      textOverflow='ellipsis'
      whiteSpace='nowrap'
    >
      {test.athlete?.name}
    </Text>
    {metric && (
      <Flex
        align='baseline'
        gap={1}
        fontSize='20px'
        fontWeight={600}
        color='var(--scoreboard-primary, #00d4ff)'
      >
        <Text as='span'>
          {roundValue(
            test[metric.value]?.value,
            test[metric.value]?.roundingPrecision
          )}
        </Text>
        <Text
          as='span'
          fontSize='14px'
          color='var(--scoreboard-text-secondary, #b0b0b0)'
        >
          {test[metric.value]?.units}
        </Text>
      </Flex>
    )}
  </Flex>
);
